import type { Tubings } from "gql/api";
import type { EquipmentTableColumn } from "@/composables/equipment/equipmentTypes";

export const tubingTableColumns: EquipmentTableColumn<Tubings>[] = [
  {
    editable: true,
    field: "include_koc_timestamp",
    header: "Include KOC",
    sortable: true,
    isCheckbox: true,
    adminOnly: true
  },
  {
    editable: true,
    field: "only_koc_timestamp",
    header: "KOC Only",
    sortable: true,
    isCheckbox: true,
    adminOnly: true
  },
  {
    editable: true,
    field: "include_ecopetrol_timestamp",
    header: "Include Ecopetrol",
    sortable: true,
    isCheckbox: true,
    adminOnly: true
  },
  {
    editable: true,
    field: "only_ecopetrol_timestamp",
    header: "Ecopetrol Only",
    sortable: true,
    isCheckbox: true,
    adminOnly: true
  },
  {
    editable: true,
    field: "imperial_name",
    header: "Name",
    sortable: true,
    searchable: true
  },
  {
    editable: true,
    field: "metric_name",
    header: "Name (Metric)",
    sortable: true,
    searchable: true
  },
  {
    editable: true,
    field: "outer_diameter_inches",
    header: "Outer Diameter (in)",
    headerShort: "OD (in)",
    isNumber: true,
    sortable: true,
    searchable: true,
    decimalPlaces: 6
  },
  {
    editable: true,
    field: "interior_diameter_inches",
    header: "Interior Diameter (in)",
    headerShort: "ID (in)",
    isNumber: true,
    sortable: true,
    searchable: true,
    decimalPlaces: 6
  },
  {
    editable: true,
    field: "drift_inches",
    header: "Drift Diameter (in)",
    headerShort: "Drift (in)",
    isNumber: true,
    sortable: true,
    searchable: true,
    decimalPlaces: 6
  },
  {
    editable: true,
    field: "coupling_outer_diameter_inches",
    header: "Coupling Outer Diameter (in)",
    headerShort: "Coupling OD (in)",
    isNumber: true,
    sortable: true,
    decimalPlaces: 6
  },
  {
    editable: true,
    field: "pound_per_foot",
    header: "Pounds per Foot",
    headerShort: "PPF",
    isNumber: true,
    sortable: true,
    decimalPlaces: 6
  },
  {
    editable: true,
    field: "tubing_type",
    header: "Tubing Type",
    isDropdown: true,
    // format function is dynamically set in useTubings() to use enum table comment as display value
    sortable: true,
    searchable: true,
    adminOnly: true
  }
];
